import { useEffect } from 'react';

export default function useOutsideClick(ref, cb) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (event && ref.current && !ref.current.contains(event.target)) {
        cb(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [cb, ref]);
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useOutsideClick.js